var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "box-main" },
    [
      _c(
        "div",
        { staticClass: "main" },
        [
          _c("div", [
            _c(
              "div",
              { staticClass: "main-title" },
              [
                _c("img", {
                  staticClass: "arrow-left",
                  attrs: {
                    src: require("@/assets/img/arrow-left.svg"),
                    alt: "",
                  },
                  on: { click: _vm.pushBack },
                }),
                _c("span", { staticClass: "ml20" }, [
                  _vm._v(_vm._s(_vm.productName)),
                ]),
                _c(
                  "v-button",
                  {
                    staticClass: "flr",
                    attrs: { type: _vm.buttonType, name: "showPublish" },
                    on: {
                      click: function ($event) {
                        return _vm.showPublishProductModel()
                      },
                    },
                  },
                  [_vm._v(_vm._s(this.status == 1 ? "撤销发布" : "发布产品"))]
                ),
              ],
              1
            ),
          ]),
          _c(
            "v-row",
            { staticClass: "tabs-demo__size" },
            [
              _c(
                "v-col",
                { attrs: { span: 22 } },
                [
                  _c(
                    "v-tabs",
                    {
                      attrs: { size: "S", name: "tabs-s-card", type: "card" },
                      model: {
                        value: _vm.activeName,
                        callback: function ($$v) {
                          _vm.activeName = $$v
                        },
                        expression: "activeName",
                      },
                    },
                    [
                      _c(
                        "v-tab-pane",
                        { attrs: { label: "产品信息", value: "1" } },
                        [
                          _c("ProductInfo", {
                            ref: "ProductInfo",
                            attrs: {
                              productName: _vm.productName,
                              productId: _vm.productId,
                              productKey: _vm.productKey,
                            },
                            on: { changStatus: _vm.changStatus },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-tab-pane",
                        { attrs: { label: "Topic 类列表", value: "2" } },
                        [
                          _c("TopicList", {
                            attrs: {
                              productName: _vm.productName,
                              productId: _vm.productId,
                              productKey: _vm.productKey,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-tab-pane",
                        { attrs: { label: "功能定义", value: "3" } },
                        [
                          _c("DefineAbility", {
                            attrs: {
                              productName: _vm.productName,
                              productId: _vm.productId,
                              productKey: _vm.productKey,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("publishModel", {
        ref: "managrDetails",
        attrs: {
          showInputDialog: _vm.publishloading,
          status: this.status,
          productName: _vm.productName,
          productId: _vm.productId,
        },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.publishloading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.publishloading = $event
          },
          changStatus: _vm.changStatus,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }